import React, { useState, useEffect } from 'react';


const TextField= () => {
    const [greeting, setGreeting] = useState('');

    useEffect(() => {
        const date = new Date();
        const hour = date.getHours();

        if (hour >= 5 && hour < 12) {
            setGreeting('Good morning');
        } else if (hour >= 12 && hour < 18) {
            setGreeting('Good afternoon');
        } else if (hour >= 18 && hour < 22) {
            setGreeting('Good evening');
        } else {
            setGreeting('Good night');
        }
    }, []); // Empty dependency array to run the effect only once on component mount

    return (
        
                <form>
                    <h2 className="text-color text-center text-light" style={{color:"lightblue"}}>{greeting} My Dear Friends</h2>
                    {/* Your form inputs and buttons go here */}
                </form>
            
        
    );
}

export default TextField;
